const notifications = (state = null, action) => {
  const { payload, type } = action;

  let filteredState;
  switch (type) {
    case 'INITIAL_DATA':
      return payload.notifications || [];

    /*
      Some notifications get updated during the day,
      eg: shoutouts, reactions

      Filter out the already present notification before inserting the new one
    */
    case 'NEW_NOTIFICATION':
      filteredState = state.filter((x) => x._id !== payload._id);
      return [payload, ...filteredState];

    case 'NEW_NOTIFICATIONS':
      filteredState = state.filter((x) => !payload.find((y) => y._id === x._id));
      return [...payload, ...filteredState];

    case 'MARK_ONE_NOTIFICATION_READ':
      return state.map((x) => (x._id !== payload.notifId ? x : { ...x, read: true }));

    case 'REFUSE_CONNECTS':
    case 'ACCEPT_CONNECTS':
      return state.map((x) => {
        if (payload.notifId !== x._id) return x;

        return {
          ...x,
          connect: {
            ...x.connect,
            status: payload.status
          }
        };
      });

    case 'UPDATE_CONNECT_STATUS':
      if (!payload.notifStatus) return state;

      return state.map((x) => {
        if (x.connect?._id !== payload.connectId) return x;

        return {
          ...x,
          updatedAt: new Date(),
          type: payload.notifStatus,
          connect: {
            ...x.connect,
            status: payload.status
          }
        };
      });

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default notifications;
